import { PreviewSurface } from '@widgets/PreviewSurface';
import { DeviceToolbar } from '@widgets/DeviceToolbar';
import { VideoFilterPanel } from '@widgets/VideoFilterPanel';
import { StreamControls } from '@widgets/StreamControls';
import { AvatarIntegrationPanel } from '@widgets/AvatarIntegrationPanel';
import { AvatarControlsPanel } from '@widgets/AvatarControlsPanel';
import { StreamStatusBar } from '@widgets/StreamStatusBar';
import { PlatformTogglesPanel } from '@widgets/PlatformTogglesPanel';
import { useAutoStartCapture } from './useAutoStartCapture';

/**
 * Preview page — single source of truth for "I am about to go live".
 *
 * Layout (top → bottom on narrow screens, two-column on wide):
 *   left column  | right column (sidebar)
 *   ─────────────┼─────────────────────────
 *   PreviewSurface
 *   DeviceToolbar
 *   VideoFilterPanel
 *   StreamControls
 *   AvatarControlsPanel
 *                | PlatformTogglesPanel
 *                | AvatarIntegrationPanel
 *
 *   ── StreamStatusBar (full width)
 */
export function PreviewPage() {
  useAutoStartCapture();

  return (
    <div className="grid h-full grid-cols-1 gap-5 overflow-y-auto p-5 xl:grid-cols-[minmax(0,1fr)_340px]">
      <div className="min-w-0 space-y-5">
        <PreviewSurface />
        <DeviceToolbar />
        <VideoFilterPanel />
        <StreamControls />
        <AvatarControlsPanel />
      </div>

      <aside className="min-w-0 space-y-5 xl:w-[340px]">
        <AvatarIntegrationPanel />
        <PlatformTogglesPanel />
      </aside>

      <div className="min-w-0 xl:col-span-2">
        <StreamStatusBar />
      </div>
    </div>
  );
}
